import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import cameraIcons from "../../assets/img/icons/add_camera_icon.png";
const FileUploader = ({ onFileSelect }) => {
  const [selectedFile, setSelectedFile] = useState(null);

  // Handle file selection and notify the parent
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    onFileSelect(file); // Pass the selected file to the parent component
  };

  // Handle file reset
  const handleFileReset = () => {
    setSelectedFile(null);
    onFileSelect(null); // Clear the selected file in the parent
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* Hidden input element to select file */}
      <input
        type="file"
        accept="image/*"
        id="file-input"
        style={{ display: "none" }} // Hide the default file input
        onChange={handleFileChange}
      />

      {/* Custom button to trigger file input */}
      <Box>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => document.getElementById("file-input").click()}
          sx={{
            color: "#000",
            fontWeight: 500,
            fontSize: { xs: "12px", sm: "13px", md: "15px" },
            width: 195,
          }}
        >
          <img
            src={cameraIcons}
            alt="icon"
            style={{ width: 22, height: 22, marginRight: 8 }}
          />
          {selectedFile ? "Change File" : "Attach Image"}
        </Button>
        <Typography
          sx={{
            fontSize: { xs: "12px", sm: "13px", md: "15px" }, 
            fontWeight: 500,
            color: "red",
            mt: 2,
          }}
        >
          Note: Image size should be less than and equals to 100KB
        </Typography>
      </Box>
      {/* Display file name if a file is selected */}
      {selectedFile && (
        <Box sx={{ mt: 1, textAlign: "left" }}>
          {/* <Typography variant="body1">
            Selected File: {selectedFile.name}
          </Typography> */}
          <Button
            variant="outlined"
            color="secondary"
            sx={{ mt: 1 }}
            onClick={handleFileReset}
          >
            Remove File
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default FileUploader;
